"use client";

import React from "react";
import { Heading } from "@/components/ui/typography";
import Image from "next/image";
const rightFrame = [
    {
        desc:"Company registration",
        icon:"/green-check.svg"
    },
     {
        desc:"Articles of Association",
        icon:"/green-check.svg"
    },
     {
        desc:"Offshore exemption claim",
        icon:"/red-check.svg"
    },
     {
        desc:"Tax position documentation",
        icon:"/red-check.svg"
    },
     {
        desc:"Annual compliance support",
        icon:"/red-check.svg"
    }
]
const leftFrame = [
    {
        desc:"Company registration",
        icon:"/green-check.svg"
    },
     {
        desc:"Articles of Association",
        icon:"/green-check.svg"
    },
     {
        desc:"Offshore exemption claim",
        icon:"/green-check.svg"
    },
     {
        desc:"Tax position documentation",
        icon:"/green-check.svg"
    },
     {
        desc:"Annual compliance support",
        icon:"/green-check.svg"
    }
]
type Props = { heading?: string; basicHeading?: string; mutetaxesHeading?: string };

export default function Wireframe2({
  heading = "Why most incorporation agencies don't handle offshore claims",
  basicHeading = "Basic formation service",
  mutetaxesHeading = "MuteTaxes",
}: Props = {}) {
  return (
    <section className="w-full bg-black md:py-16 py-[30px] px-4">
      <div className="max-w-[1200px] mx-auto flex flex-col items-center gap-[50px]">

        {/* HEADER */}
        <div className="flex flex-col items-center text-center gap-6 max-w-[782px]">
          <Heading as="h2" variant="sectionCentered" className="w-full md:w-[714px]">
            {heading}
          </Heading>

          <p className="text-[16px] leading-[24px] font-medium text-white/70 w-full md:w-[834px]">
            Many providers help with company formation only. They file the Certificate of Incorporation,
            Business Registration Certificate, and Articles of Association — then stop.
            <br />
            But formation alone does not determine tax treatment. Your offshore profits exemption application
            determines whether your company qualifies for 0% taxation.
          </p>
        </div>

        {/* CARDS SECTION */}
        <div className="relative w-full flex flex-col lg:flex-row gap-8 h-auto">

          {/* LEFT CARD */}
          <div className="flex-1 bg-[#0f1218] rounded-[16px] p-6 flex flex-col gap-6">
            <Heading as="h3" variant="cardTitleLight">
              {basicHeading}
            </Heading>

            <div className="flex flex-col gap-3 flex-1">

              {/* ITEM */}
              {rightFrame.map((value,index) => {
                return  <div key={index} className="flex items-center gap-2 bg-white/5 rounded-[8px] p-4">
                <Image src={value.icon} alt="" width={28} height={28} />
                <p className="text-[18px] text-white">{value.desc}</p>
              </div>
              })}

            </div>
          </div>

          {/* VS BADGE */}
          <div className="hidden lg:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#4442f0] text-white w-[50px] h-[50px] rounded-full items-center justify-center border-[6px] border-black font-bold uppercase text-[14px]">
            vs
          </div>

          {/* RIGHT CARD */}
          <div className="flex-1 bg-[#0f1218] rounded-[16px] p-6 flex flex-col gap-6 border-2 border-[#005c00]">
            <Heading as="h3" variant="cardTitleLight">
              {mutetaxesHeading}
            </Heading>

            <div className="flex flex-col gap-3">
{leftFrame.map((value,index) => {
    return <div key={index} className="flex items-center gap-2 bg-white/5 rounded-[8px] p-4">
                <Image src={value.icon} alt="" width={28} height={28} />
                <p className="text-[18px] text-white">{value.desc}</p>
              </div>
})}
              

             

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}